export enum FEATURE_FLAG {
  BUILDER_UI = 'builder-ui',
  BUILDER_UI_JDM_UPLOAD = 'builder-ui-jdm-upload',
  BUILDER_UI_AI_ABSTRACTED_SOURCES = 'builder-ui-ai-abstracted-sources',
  SHOW_TRIAL_TYPE_FILTER = 'show-trial-type-filter',
  CARE_PATHWAYS = 'care-pathways',
  GAEL = 'gael',
  MANUAL_NEXT_SEARCH = 'manual-next-search',
  SITE_TRIALS = 'site-trials',
}
